/*
 * "Notify me when available" buttons → popup with the Omnisend back-in-stock
 * form (snippets/back-in-stock-popup.liquid).
 *
 * Omnisend only shows its back-in-stock form while it has an out-of-stock
 * product on record, and it records one by itself only on product pages, for
 * the variant the page was loaded with. So on every click the product and
 * variant of that button are handed to Omnisend — the same record its own
 * product-page detection builds — which makes the form work on collection
 * cards and for whichever variant is selected on the product page. Omnisend
 * reads that record again when the form is submitted.
 *
 * Buttons: [js-notify-button] with data-product-handle, and either
 * data-variant-id or, on the product page, the variant of the form they sit in.
 */
(function () {
  var popup = document.querySelector('[js-bis-popup]');
  if (!popup) return;

  var formSlot = document.getElementById('omnisend-embedded-v2-' + popup.getAttribute('data-form-id'));
  var panel = popup.querySelector('.bis-popup__panel');
  var productLabel = popup.querySelector('[js-bis-product]');
  var loading = popup.querySelector('[js-bis-loading]');
  var unavailable = popup.querySelector('[js-bis-unavailable]');
  var lastFocus = null;
  var request = 0;

  var FORM_WAIT_MS = 5000;

  function absolute(url) {
    if (!url) return '';
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  function productJsonUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function formRendered() {
    return !!(formSlot && formSlot.children.length);
  }

  // The form div itself is never hidden: Omnisend renders into it, and it is
  // simply empty until then.
  function setState(state) {
    if (loading) loading.hidden = state !== 'loading';
    if (unavailable) unavailable.hidden = state !== 'unavailable';
  }

  function open() {
    lastFocus = document.activeElement;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bis-popup-open');
    if (panel) panel.focus();
  }

  function close() {
    request += 1;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bis-popup-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  // Same shape as the record Omnisend builds on product pages (launcher-v2.js).
  function tellOmnisend(product, variant) {
    var omnisend = window._omnisend;
    if (!omnisend || typeof omnisend.setProductInfo !== 'function') return false;
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    var image = absolute((variant.featured_image && variant.featured_image.src) || product.featured_image);
    var productUrl = window.location.origin + product.url;
    omnisend.setProductInfo({
      properties: {
        product: {
          id: String(product.id),
          currency: currency,
          price: typeof variant.price === 'number' ? variant.price : product.price,
          oldPrice: typeof variant.compare_at_price === 'number' ? variant.compare_at_price : product.compare_at_price,
          title: variant.name || product.title,
          description: product.description,
          imageUrl: image,
          url: productUrl + '?variant=' + variant.id,
          status: 'outOfStock',
          variantId: String(variant.id),
          productTitle: product.title,
          productImageUrl: absolute(product.featured_image),
          productUrl: productUrl
        }
      }
    });
    return true;
  }

  // Omnisend checks its forms on a timer, so the form can take a moment.
  function waitForForm(id) {
    var started = Date.now();
    (function check() {
      if (id !== request) return;
      if (formRendered()) {
        setState('ready');
        return;
      }
      if (Date.now() - started > FORM_WAIT_MS) {
        setState('unavailable');
        return;
      }
      setTimeout(check, 150);
    })();
  }

  function variantIdFor(button) {
    if (button.hasAttribute('data-variant-id')) return button.getAttribute('data-variant-id');
    var form = button.closest('form');
    var input = form && form.querySelector('input[name="id"]');
    return input ? input.value : '';
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('[js-notify-button]');
    if (button) {
      e.preventDefault();
      var handle = button.getAttribute('data-product-handle');
      var variantId = variantIdFor(button);
      if (!handle) return;

      var id = (request += 1);
      if (productLabel) productLabel.textContent = button.getAttribute('data-product-title') || '';
      setState('loading');
      open();

      fetch(productJsonUrl(handle), { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Product ' + handle + ': ' + res.status);
          return res.json();
        })
        .then(function (product) {
          if (id !== request) return;
          var variant =
            (product.variants || []).filter(function (v) {
              return String(v.id) === String(variantId);
            })[0] || (product.variants || [])[0];
          if (!variant || !tellOmnisend(product, variant)) {
            setState('unavailable');
            return;
          }
          waitForForm(id);
        })
        .catch(function () {
          if (id === request) setState('unavailable');
        });
      return;
    }

    if (e.target.closest('[js-bis-close]') && popup.classList.contains('is-open')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
  });
})();
